var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(!_vm.isLoading)?_c('div',[_c('vue-page-transition',{attrs:{"name":"fade-in-left"}},[_c('router-view')],1)],1):_vm._e(),_c('NewApplicationModal'),_c('CreditScoreQuestionsModal'),_c('OverlayLoader',{attrs:{"show":_vm.isLoading}}),_c('PaymentsModal',{attrs:{"info-text":_vm.$t(
                _vm.settings.payments.offer_help_text
                    ? _vm.settings.payments.offer_help_text
                    : 'pay.help_text_modal'
            )}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }